import { SchemaCreditCard } from "models";
import { EnumFormaPagamento } from "services";
import { cleanMoneyMask } from "utils";
import * as yup from "yup";

export const CreditCardSchema = yup.object({
  installments: yup.string().required("Selecione uma parcela"),
  number: yup
    .string()
    .min(16, "Número do cartão inválido")
    .required("Número do cartão é obrigatório"),
  due_date: yup
    .string()
    .matches(/^(0[1-9]|1[0-2])\/\d{2}$/, "Validade no formato MM/AA")
    .required("Validade é obrigatória"),
  cvv: yup
    .string()
    .min(3, "CVV inválido")
    .max(4, "CVV inválido")
    .required("CVV é obrigatório"),
  name: yup.string().required("Nome do titular é obrigatório"),
  cpfCnpj: yup
    .string()
    .min(11, "CPF/CNPJ inválido")
    .max(18, "CPF/CNPJ inválido")
    .required("CPF ou CNPJ é obrigatório"),
});

export const DebitCardSchema = SchemaCreditCard.omit(["id_charge_option"]);

export const PixSchema = yup.object({
  value: yup
    .string()
    .required("Informe o valor a ser pago")
    .test("is-greater-than-min", "Valor deve ser maior ou igual R$ 5,00", (val) => {
      return cleanMoneyMask(val) >= 5.0;
    }),
});

export const TwoMethodsCreditSchema = SchemaCreditCard.concat(
  yup.object({
    value: yup
      .string()
      .required("Informe o valor a ser pago")
      .test(
        "is-greater-than-min",
        "Valor deve ser maior ou igual R$ 5,00",
        (val) => {
          return cleanMoneyMask(val) >= 5.0;
        }
      ),
  })
);

export function handleSchemaValidation(type: EnumFormaPagamento) {
  switch (type) {
    case EnumFormaPagamento.CREDITO:
      return SchemaCreditCard;
    case EnumFormaPagamento.DEBITO:
      return DebitCardSchema;
    case EnumFormaPagamento.PIX:
      return PixSchema;
    case EnumFormaPagamento.MULTIPLE_CREDIT:
      return TwoMethodsCreditSchema;
    default:
      return yup.object({});
  }
}
